import { SearchContext } from '@giphy/react-components'

import { useContext, useEffect, useRef } from 'react'
// @ts-ignore
import { disablePageScroll as lock, enablePageScroll as unlock } from 'scroll-lock'
import { BodyScrollLockContext } from '.'

const BodyScrollLock = () => {
    const { isFocused } = useContext(SearchContext)
    const { ignoreTarget } = useContext(BodyScrollLockContext)
    const lockedEl = useRef<Element | null>(null)
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (ignoreTarget) {
                const el = document.querySelector(ignoreTarget)
                if (isFocused) {
                    if (ignoreTarget && !el) {
                        console.log(`body scroll lock ${ignoreTarget} not found`)
                    }
                    unlock(lockedEl.current)
                    lockedEl.current = el
                    lock(el)
                } else {
                    unlock(el)
                }
            }
        }, 500)
        return () => {
            unlock(lockedEl.current)
            clearTimeout(timeout)
        }
    }, [isFocused, ignoreTarget])
    return null
}

export default BodyScrollLock
